import { Input } from "design-react-kit";
import { useEffect, useState, useContext } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import ModalComponent from "../../Components/ModalComponent";
import Select from "../../Components/Select";
import Repo from "../../Utility/Repo";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { PROVINCE } from "../../Components/listaProvince";
import { NAZIONI } from "../../Components/listaNazioni";
import { TokenContext } from "../../Components/TokenContext";
import { AlertMessage, showError } from "../../Components/AlertMessage";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function NewUser(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [validationEmail, setValidationEmail] = useState(true);
  const [validationCF, setValidationCF] = useState(true);
  const [listaProvince] = useState(PROVINCE);
  const [listaNazioni] = useState(NAZIONI);
  const [isOpenImport, toggleModalImport] = useState(false);

  const [apiError, setApiError] = useState({});
  const [nazionePredefinita, setNazionePredefinita] = useState({});
  const [codiceFiscale, setCodiceFiscale] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [userInfo, setUserInfo] = useState({});

  const history = useHistory();

  let query = useQuery();

  const [data, setData] = useState({
    firstName: null,
    lastName: null,
    birthDate: null,
    fiscalCode: null,
    email: null,
    phoneNumber: null,
    address: null,
    addressNumber: null,
    cap: null,
    country: props?.comuneDelegate ? "LE" : null,
    city: props?.comuneDelegate ? props.comuneDelegate : null,
    nation: "IT",
    municipioId: null,
    gender: null,
    homeAddress: null,
  });

  const handleChange = (e) => {
    const value = e.target.value.toUpperCase(); // Converti sempre in maiuscolo
    setCodiceFiscale(value);

    // Aggiorna la validazione ogni volta che il campo cambia
    if (value.length === 16) {
      setIsValid(isValidCodiceFiscale(value));
    } else {
      setIsValid(true); // Non mostrare errori finché non raggiunge 16 caratteri
    }
  };

  const handleBlur = () => {
    // Esegui la validazione solo quando l'utente esce dal campo
    if (codiceFiscale.length === 16) {
      setIsValid(isValidCodiceFiscale(codiceFiscale));
    } else {
      setIsValid(false); // Errore se è vuoto o meno di 16 caratteri
    }
  };

  useEffect(() => {
    setNazionePredefinita(
      listaNazioni.find((opzione) => opzione.value === "IT")
    );
  }, []);

  const handleSelectChange = (selectedOption) => {
    setNazionePredefinita(
      listaNazioni.find((opzione) => opzione.value === selectedOption.value)
    );
    setData({ ...data, nation: selectedOption ? selectedOption.value : "IT" });
  };

  function isValidCodiceFiscale(codiceFiscale) {
    const cfRegex = /^[A-Z0-9]{16}$/; // Verifica 16 caratteri alfanumerici
    return cfRegex.test(codiceFiscale);
  }

  const newUserValidation = () => {
    const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    setValidation(true);
    let passedValidation = true;

    if (data.email && !data.email.match(regexEmail)) {
      setValidationEmail(false);
    } else {
      setValidationEmail(true);
    }

    if (data.fiscalCode && data.fiscalCode.length != 16) {
      setValidationCF(false);
    } else {
      setValidationCF(true);
    }

    Object.entries(data).map(([key, value]) => {
      if (
        value === null &&
        key !== "emailPec" &&
        key !== "email" &&
        key !== "phoneNumber" &&
        key !== "municipioId" &&
        key !== "municipio" &&
        key !== "homeAddress"
      ) {
        passedValidation = false;
      }
    });

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const handleAlertClose = () => {
    setApiError({ isVisible: false, message: "" });
  };

  const handleSearch = async () => {
    if (!isValid) return; // Non procedere se il codice fiscale non è valido

    try {
      const response = await Repo.getAnagraficaCerca(apiToken, codiceFiscale);
      // Verifica se l'utente esiste
      if (response.data && response.data?.fiscalCode) {
        setUserInfo(response.data); // imposta i dati dell'utente
      } else {
        setUserInfo(null);
        alert("Codice Fiscale non presente nel database.");
      }
    } catch (error) {
      console.error("Errore nella chiamata API", error);
      alert("Si è verificato un errore durante la ricerca.");
    }
  };

  const importUser = async () => {
    if (!isValid) return; // Non procedere se il codice fiscale non è valido

    try {
      const response = await Repo.getAnagraficaInserisci(
        apiToken,
        codiceFiscale
      );

      const id = await response.data;
      // Verifica se l'utente esiste
      if (id != null) {
        setUserInfo(null); // imposta i dati dell'utente
        history.push(`/lista_utenti/cartella_sociale?id=${id}`);
      } else {
        setUserInfo(null);
        alert("Codice Fiscale non presente nel database.", id);
      }
    } catch (error) {
      console.error("Errore nella chiamata API", error);
      alert("Si è verificato un errore durante la ricerca.");
    }
  };

  const bodyImport = () => {
    return (
      <>
        <div className="row mh-100">
          <div className="form-check col-6">
            <div className="toggles mb-2">
              <div>
                <label>
                  Codice Fiscale:
                  <input
                    className="float-left"
                    type="text"
                    value={codiceFiscale}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    maxLength="16" // Limita la lunghezza massima
                    style={{ borderColor: isValid ? "black" : "red" }} // Bordo rosso per errore
                  />
                  <div className="input-group-append">
                    <button
                      className="btn"
                      type="button"
                      id="button-2"
                      onClick={handleSearch}
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-search`} />
                      </svg>{" "}
                    </button>
                  </div>
                </label>
                {!isValid && (
                  <p style={{ color: "red" }}>Codice Fiscale non valido.</p>
                )}
                {userInfo?.fiscalCode && (
                  <div className="user-info">
                    <br />
                    <p>
                      <strong>Nome:</strong> {userInfo.firstName}
                      <br />
                      <strong>Cognome:</strong> {userInfo.lastName}
                      <br />
                      <strong>Data di Nascita:</strong> {userInfo.birthDate}
                      <br />
                      <strong>Indirizzo:</strong> {userInfo.address}{" "}
                      {userInfo.addressNumber}, {userInfo.city} (
                      {userInfo.country})
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="form-check col-6">
            <div className="toggles">&nbsp;</div>
          </div>
        </div>
      </>
    );
  };

  const insertUserAPI = () => {
    const urlBack = query.get("urlBack");
    Repo.postInsertUser(apiToken, JSON.stringify(data))
      .then((response) => {
        if (response.status === 200) {
          let userId = response.data.id;
          // Successo, esegui le azioni necessarie
          window.location.href =
            props.subfolder + "/lista_utenti/cartella_sociale?id=" + userId;
        } else {
          // Altri codici di stato di risposta
          // Gestisci di conseguenza
        }
      })
      .catch((error) => {
        toggleModal(!isOpen);

        setApiError({ isVisible: true, message: showError(error) });
      });
  };

  return (
    <>
      <div>
        {apiError.isVisible && (
          <AlertMessage
            isVisible={apiError.isVisible}
            error={apiError.message}
            onClose={handleAlertClose}
          />
        )}

        <h1>Nuovo utente</h1>
        <div className="row">
          <div className="col-lg-8 py-lg-2">
            <p>Inserisci un nuovo utente</p>
          </div>
          <div className="col-4 text-right">
            <button
              type="button"
              className="btn btn-outline-primary float-right p-2"
              onClick={() => toggleModalImport(!isOpenImport)}
            >
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-download`} />
              </svg>{" "}
              <span className="align-middle">Importa da ANPR</span>
            </button>
          </div>
        </div>

        <div className="col-lg-12 mt-3">
          <div className="row">
            <div className="col-lg-4">
              <Input
                id="first_name"
                required
                label="Nome*"
                type="text"
                name="first_name"
                {...(validation &&
                  !data.firstName && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
                onChange={(e) =>
                  setData({ ...data, firstName: e.target.value })
                }
              />
            </div>
            <div className="col-lg-4">
              <Input
                id="last_name"
                required
                label="Cognome*"
                type="text"
                name="last_name"
                onChange={(e) => setData({ ...data, lastName: e.target.value })}
                {...(validation &&
                  !data.lastName && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-4">
              <Input
                id="fiscal_code"
                required
                label="Codice Fiscale*"
                type="text"
                name="fiscal_code"
                onChange={(e) =>
                  setData({ ...data, fiscalCode: e.target.value })
                }
                {...(validation &&
                  !data.fiscalCode && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
                {...(validation & !validationCF && {
                  infoText: "Il codice fiscale è errato!",
                  className: "text-danger error_div is-invalid",
                })}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-3">
              <Input
                id="birthdate"
                required
                label="Data di Nascita*"
                type="date"
                name="birthdate"
                placeholder="gg/mm/aaaa"
                onChange={(e) =>
                  setData({ ...data, birthDate: e.target.value })
                }
                {...(validation &&
                  !data.birthDate && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-4">
              <Input
                id="email"
                required
                label="Email"
                type="text"
                name="email"
                onChange={(e) => setData({ ...data, email: e.target.value })}
                // {...(validation &&
                //   !data.email && {
                //     infoText: "Il campo non può essere vuoto!",
                //     className: "text-danger error_div is-invalid",
                //   })}
                {...(validation &&
                  !validationEmail && {
                    infoText: "Il formato dell'email non è corretto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-3">
              <Input
                id="emailPec"
                label="Pec"
                type="text"
                name="emailPec"
                onChange={(e) => setData({ ...data, emailPec: e.target.value })}
              />
            </div>
            <div className="col-lg-2">
              <Input
                id="phone_number"
                label="Telefono"
                type="text"
                name="phone_number"
                onChange={(e) =>
                  setData({ ...data, phoneNumber: e.target.value })
                }
                // {...(validation &&
                //   !data.phoneNumber && {
                //     infoText: "Il campo non può essere vuoto!",
                //     className: "text-danger error_div is-invalid",
                //   })}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-lg-6">
              <Input
                id="address"
                required
                label="Indirizzo*"
                type="text"
                name="address"
                onChange={(e) => setData({ ...data, address: e.target.value })}
                {...(validation &&
                  !data.address && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-3">
              <Input
                id="number"
                required
                label="N. Civico*"
                type="text"
                name="number"
                onChange={(e) =>
                  setData({ ...data, addressNumber: e.target.value })
                }
                {...(validation &&
                  !data.addressNumber && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-3">
              <Input
                id="cap"
                required
                label="CAP*"
                type="text"
                name="cap"
                onChange={(e) => setData({ ...data, cap: e.target.value })}
                {...(validation &&
                  !data.cap && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
          </div>
          <div className="row">
            <div className="mt-n2 col-2">
              <div className="small text-muted">
                <strong>Sesso*</strong>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className="cmp-card-radio">
                    {" "}
                    <div className="radio-body">
                      <input
                        id="sessoM"
                        name="sesso"
                        value="M"
                        type="radio"
                        className="mr-2"
                        checked={data.gender === "M"}
                        style={{ cursor: "pointer" }}
                        onChange={(e) =>
                          setData({ ...data, gender: e.target.value })
                        }
                      />
                      <label
                        htmlFor="sessoM"
                        className="active"
                        style={{ cursor: "pointer" }}
                      >
                        <strong>M</strong>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="radio-body">
                    <input
                      type="radio"
                      id="sessoF"
                      name="sesso"
                      value="F"
                      className="mr-2"
                      checked={data.gender === "F"}
                      style={{ cursor: "pointer" }}
                      onChange={(e) =>
                        setData({ ...data, gender: e.target.value })
                      }
                    />
                    <label
                      htmlFor="sessoF"
                      className="active"
                      style={{ cursor: "pointer" }}
                    >
                      <strong>F</strong>
                    </label>
                  </div>
                </div>
              </div>
              {validation && !data.gender ? (
                <small id="errorSelect" className="form-text text-danger">
                  Il campo non può essere vuoto!
                </small>
              ) : (
                <></>
              )}
            </div>
            <div className="col-lg-4 mt-2">
              <Input
                id="homeAddress"
                label="Domicilio"
                type="text"
                name="homeAddress"
                value={data && data.homeAddress ? data.homeAddress : ""}
                onChange={(e) =>
                  setData({ ...data, homeAddress: e.target.value })
                }
              />
              <small className="form-text text-muted mt-n3">
                Se diverso dall'indirizzo di residenza
              </small>
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-4">
            <Input
              id="city"
              required
              label="Città*"
              type="text"
              name="city"
              value={data.city ? data.city : ""}
              disabled={props?.comuneDelegate ? true : false}
              onChange={(e) => setData({ ...data, city: e.target.value })}
              {...(validation &&
                !data.city && {
                  infoText: "Il campo non può essere vuoto!",
                  className: "text-danger error_div is-invalid",
                })}
            />
          </div>
          <div className="col-lg-4">
            <div className="bootstrap-select-wrapper col-12">
              <Select
                aria-label="Scegli una provincia*"
                clearText="Annulla"
                defaultMenuIsOpen={false}
                icon={false}
                value={
                  listaProvince.find((opt) => opt.value === data.country) ||
                  null
                }
                isDisabled={props?.comuneDelegate ? true : false}
                id="selectExampleClassic"
                onChange={(e) => {
                  setData({ ...data, country: e.value });
                }}
                options={listaProvince}
                isSearchable={true}
                placeholder={"Scegli una provincia*"}
              />
            </div>
            {validation && !data.country ? (
              <small id="errorSelect" className="form-text text-danger">
                Il campo non può essere vuoto!
              </small>
            ) : (
              <></>
            )}
          </div>
          <div className="col-lg-4">
            <div className="bootstrap-select-wrapper col-12">
              <Select
                aria-label="Scegli una nazione*"
                clearText="Annulla"
                defaultMenuIsOpen={false}
                icon={false}
                id="selectExampleClassic"
                onChange={handleSelectChange}
                options={listaNazioni}
                value={nazionePredefinita}
                isSearchable
                isDisabled={props?.comuneDelegate ? true : false}
                //  placeholder={"Scegli una nazione*"}
              />
            </div>
            {validation && !data.nation ? (
              <small id="errorSelect" className="form-text text-danger">
                Il campo non può essere vuoto!
              </small>
            ) : (
              <></>
            )}
          </div>
        </div>

        <div className="row my-2">
          <div className="col-lg-12 text-right">
            <button
              type="button"
              className="btn btn-primary"
              data-toggle="tooltip"
              data-placement="top"
              onClick={() => newUserValidation()}
              title="Conferma"
            >
              Conferma
            </button>
          </div>
        </div>

        <ModalComponent
          toggleModal={toggleModal}
          isOpen={isOpen}
          header="Inserimento nuovo utente"
          body="Confermi di voler inserire un nuovo utente?"
          buttonConfirm="Conferma"
          buttonDeny="Annulla"
          function={() => insertUserAPI()}
        ></ModalComponent>

        <ModalComponent
          toggleModal={toggleModalImport}
          isOpen={isOpenImport}
          header="Importa cittadino da ANPR"
          body={bodyImport()}
          buttonConfirm="Inserisci"
          buttonDeny="Annulla"
          function={() => importUser()}
        ></ModalComponent>
      </div>
    </>
  );
}

export default NewUser;
